import PropTypes from 'prop-types'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'

const FormDeleteDialog = ({
  open,
  setOpen = () => {},
  refresh = () => {},
  organizationId,
  setIsLoading,
}) => {
  const snackbar = useSnackbar()

  const { handleSubmit } = useForm()

  const onSubmit = async () => {
    try {
      setIsLoading(true)
      await service.backoffice.organizations.softDelete({
        organizationId,
      })

      snackbar.open({
        message: 'Grupo Advisor excluído com sucesso.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
      })
    } finally {
      setOpen(false)
      setIsLoading(false)
      refresh()
    }
  }

  const handleClose = () => setOpen((prevState) => !prevState)

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>
          <Box>
            <Typography variant="h5">Excluir Grupo Advisor</Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box>
            <Typography variant="h4" align="center">
              Tem certeza que deseja excluir este Grupo Advisor? Não será
              possível reverter esta ação!
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions p={2}>
          <Box pl={2} pr={1}>
            <Button type="button" variant="outlined" onClick={handleClose}>
              Cancelar
            </Button>
          </Box>
          <Button variant="contained" type="submit" color="primary">
            Excluir
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

FormDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  organizationId: PropTypes.number,
  setIsLoading: PropTypes.func,
}

export default FormDeleteDialog
